import { useMemo } from "react"

import type { Device } from "types/device.types"

import { getTowerTabPlotDefs } from "helpers/config/dashboards"
import { BodyContainer } from "widgets/styled/containers"
import DevicePosition from "./DevicePosition"
import Dashboard from "."

interface DeviceTowerDashboardProps {
  device: Device
}

const DeviceTowerDashboard = ({ device }: DeviceTowerDashboardProps) => {
  const config = useMemo(
    () => ({
      type: "deviceTowerTab",
      plotDefs: getTowerTabPlotDefs(device.settings?.features ?? {}),
    }),
    [device.settings?.features],
  )

  return (
    <BodyContainer disableGutters maxWidth="xl">
      <Dashboard device={device} config={config}>
        <DevicePosition deviceId={device.id} />
      </Dashboard>
    </BodyContainer>
  )
}

export default DeviceTowerDashboard
